import {
    AuthenticationResult,
    Configuration,
    IPublicClientApplication,
    InteractionRequiredAuthError,
    PublicClientApplication,
} from '@azure/msal-browser'

import { getAppConfig } from '@utils/globals'

export const getMsalConfig = (): Configuration | null => {
    const {
        azureAdClientId,
        azureAdTenantId,
        azureAdRedirectUrl,
        azureAuthorityBaseUrl,
    } = getAppConfig()
    if (
        !azureAdClientId ||
        !azureAdTenantId ||
        !azureAdRedirectUrl ||
        !azureAuthorityBaseUrl
    )
        return null

    return {
        auth: {
            clientId: azureAdClientId ?? '',
            authority: `${azureAuthorityBaseUrl}${azureAuthorityBaseUrl.endsWith('/') ? '' : '/'}${azureAdTenantId}`,
            redirectUri: azureAdRedirectUrl,
        },
        cache: {
            cacheLocation: 'localStorage',
            storeAuthStateInCookie: true,
        },
    }
}

export const getMsalInstance = () => {
    const msalConfig = getMsalConfig()

    if (!msalConfig) return null

    return new PublicClientApplication(msalConfig)
}

export const getMsalRequest = () => {
    const { azureAdClientId } = getAppConfig()

    return {
        scopes: azureAdClientId
            ? [`api://${azureAdClientId}/access_as_user`]
            : [],
    }
}

export const requestMsalAccessToken = async (
    instance: IPublicClientApplication
): Promise<AuthenticationResult | void> => {
    const account = instance.getAllAccounts()[0]
    try {
        const scopes = getMsalRequest()?.scopes ?? []
        const response = await instance
            .acquireTokenSilent({ account, scopes })
            .catch(async (error) => {
                if (error instanceof InteractionRequiredAuthError) {
                    console.error(error)
                    return await instance
                        .acquireTokenPopup({
                            scopes,
                            loginHint: account.username,
                        })
                        .catch(async (error) => {
                            console.error(error)
                            return await instance.acquireTokenRedirect({
                                scopes,
                                loginHint: account.username,
                            })
                        })
                }
            })
        return response
    } catch (error) {
        console.error(error)
        return
    }
}
